import { Button, HStack, Text, VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Props } from "./types";
import { Input } from "semente-js";
import { Modal } from "src/components/base/Modal";
import Checkbox from "src/components/Checkbox";
import { IndicatorType } from "src/types";

const IndicatorTypeForm: React.FC<Props> = ({
  handleSubmitIndicatorType,
  handleClose,
  indicatorType,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm<IndicatorType>({
    defaultValues: indicatorType,
  });

  useEffect(() => {
    reset(indicatorType || { is_active: true } as any);
  }, [indicatorType, reset]);

  return (
    <Modal
      title={
        indicatorType && "id" in indicatorType
          ? "Editar estágio"
          : "Criar estágio"
      }
      isOpen={!!indicatorType}
      onClose={handleClose}
    >
      <VStack
        spacing={"16px"}
        w={"100%"}
        alignItems={"flex-start"}
        px={"24px"}
        borderTop={"1px solid"}
        borderBottom={"1px solid"}
        borderColor={"Gray.$300"}
        py={"24px"}
      >
        <Controller
          name={"name"}
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <Input
              id="name-field"
              {...field}
              {...(error && { errorMessage: "Este campo é obrigatório" })}
              placeholder={"Nome do estágio"}
            />
          )}
        />

        <Controller
          name={"is_active"}
          control={control}
          render={({ field: { value, onChange } }) => (
            <HStack>
              <Checkbox isChecked={value} onChange={onChange} />
              <Text>Ativo</Text>
            </HStack>
          )}
        />
      </VStack>

      <Button
        m={"24px !important"}
        borderRadius={"8px"}
        variant={"Primary"}
        minH={"48px !important"}
        isLoading={isSubmitting}
        onClick={handleSubmit(handleSubmitIndicatorType)}
      >
        {indicatorType && "id" in indicatorType ? "Salvar" : "Adicionar"}
      </Button>
    </Modal>
  );
};

export default IndicatorTypeForm;

